var _linearGradient, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpecial = function SvgSpecial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "special_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 12.001,
    x2: 12.001,
    y1: 0.793,
    y2: 23.209
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFC227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA927"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1.232 10.94a1.5 1.5 0 0 0 0 2.122l2.35 2.349v3.312a1.5 1.5 0 0 0 1.5 1.5h3.312l2.547 2.547a1.5 1.5 0 0 0 2.121 0l2.547-2.547h3.202a1.5 1.5 0 0 0 1.5-1.5v-3.202l2.46-2.46a1.5 1.5 0 0 0 0-2.12l-2.46-2.46V4.993a1.5 1.5 0 0 0-1.5-1.5h-3.488l-2.261-2.26a1.5 1.5 0 0 0-2.121 0l-2.262 2.26H5.081a1.5 1.5 0 0 0-1.5 1.5v3.599z",
    fill: "url(#special_svg__a)",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6 11 4 4 7-7",
    stroke: "#fff",
    strokeWidth: 1.8
  })));
};
export default SvgSpecial;